export const CARDS_RESOURCE = 'planning.cards';
export const checklistKey = (eventId: string) => ['planning', 'checklist', eventId] as const;

export type ChecklistItem = { id: string; text: string; sort: number; done: boolean; doneBy: string | null; doneByName: string | null; doneAt: string | null; version: number };
/** As the API sends it; `items` is absent when the role may not see the checklist. */
export type Checklist = { eventId: string; templateId?: string | null; items?: ChecklistItem[] };

export type TemplateSuggestion = { id: string; name?: string; scopes?: string[]; systemId?: string | null; matched: number };
